export default "__VITE_ASSET__LWSocjwA__"